import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { EXTERNAL_LINKS } from '../../constants/links';

// CTA按钮处理组件
const CTAHandler = {
  // 免费试用处理
  handleFreeTrial: () => {
    // 添加用户行为追踪
    if (typeof gtag !== 'undefined') {
      gtag('event', 'click', {
        event_category: 'CTA',
        event_label: 'Free Trial',
        value: 1
      });
    }
    
    // 打开登录页面
    window.open(EXTERNAL_LINKS.LOGIN_URL, '_blank');
  },

  // 预约演示处理
  handleBookDemo: () => {
    // 添加用户行为追踪
    if (typeof gtag !== 'undefined') {
      gtag('event', 'click', {
        event_category: 'CTA',
        event_label: 'Book Demo',
        value: 1
      });
    }
    
    // 打开演示预约表单
    window.open(EXTERNAL_LINKS.DEMO_FORM, '_blank');
  },

  // 了解更多处理
  handleLearnMore: () => {
    // 添加用户行为追踪
    if (typeof gtag !== 'undefined') {
      gtag('event', 'click', {
        event_category: 'CTA',
        event_label: 'Learn More',
        value: 1
      });
    }
    
    // 打开产品信息PDF
    window.open(EXTERNAL_LINKS.PRODUCT_INFO, '_blank');
  },

  // 登录处理
  handleLogin: () => {
    // 添加用户行为追踪
    if (typeof gtag !== 'undefined') {
      gtag('event', 'click', {
        event_category: 'Navigation',
        event_label: 'Login',
        value: 1
      });
    }
    
    // 打开登录页面
    window.open(EXTERNAL_LINKS.LOGIN_URL, '_blank');
  }
};

// 增强的CTA按钮组件
export const EnhancedCTAButton = ({ 
  children, 
  variant = 'primary', 
  action = 'freeTrial',
  className = '',
  disabled = false,
  loading = false,
  ...props 
}) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = () => {
    if (disabled || loading) return;
    
    setIsClicked(true);
    
    // 执行对应的CTA动作
    switch (action) {
      case 'freeTrial':
        CTAHandler.handleFreeTrial();
        break;
      case 'bookDemo':
        CTAHandler.handleBookDemo();
        break;
      case 'learnMore':
        CTAHandler.handleLearnMore();
        break;
      case 'login':
        CTAHandler.handleLogin();
        break;
      default:
        console.warn(`Unknown CTA action: ${action}`);
    }
    
    // 重置点击状态
    setTimeout(() => setIsClicked(false), 200);
  };

  const baseClasses = "relative inline-flex items-center justify-center px-6 py-3 font-medium rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variantClasses = {
    primary: "bg-primary-600 hover:bg-primary-700 text-white focus:ring-primary-500 shadow-lg hover:shadow-xl",
    secondary: "bg-white/10 hover:bg-white/20 text-white border border-white/20 hover:border-white/30 focus:ring-white/50",
    outline: "border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white focus:ring-primary-500"
  };

  const disabledClasses = "opacity-50 cursor-not-allowed";
  const loadingClasses = "cursor-wait";

  return (
    <motion.button
      className={`
        ${baseClasses} 
        ${variantClasses[variant]} 
        ${disabled ? disabledClasses : ''} 
        ${loading ? loadingClasses : ''} 
        ${className}
      `}
      onClick={handleClick}
      disabled={disabled || loading}
      whileHover={!disabled && !loading ? { scale: 1.05 } : {}}
      whileTap={!disabled && !loading ? { scale: 0.95 } : {}}
      animate={isClicked ? { scale: [1, 0.95, 1] } : {}}
      transition={{ duration: 0.2 }}
      {...props}
    >
      {loading && (
        <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      )}
      {children}
    </motion.button>
  );
};

export default CTAHandler;
